<template>
  <div pr-hold-or-not-slide>
    <template v-if="sect === 'sm' || sect === 'md'">
      <slot />
    </template>
    <template v-else>
      <template v-if="direction === 'b2t'">
        <PrHoldBottom :id="id" :img="img" :title="title" :desc="desc" :subTitle="subTitle" :html="html" :text="text" :direction="direction"
          :position="position">
          <slot name="holdBottom" />
        </PrHoldBottom>
      </template>
      <template v-else>
        <PrHoldLeft :id="id" :img="img" :title="title" :desc="desc" :subTitle="subTitle">
          <slot name="holdLeft" />
        </PrHoldLeft>
      </template>
    </template>
  </div>
</template>

<script>
import PrHoldLeft from "@/views/components/PrHoldLeft";
import PrHoldBottom from "@/views/components/PrHoldBottom";
export default {
  name: "PrHoldOrNotSlide",
  components: { PrHoldLeft, PrHoldBottom },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "left",
    },
    img: { type: String },
    id: { type: String },
    mobileHeight: { default: "0" },
    direction: { default: "" },
    html: { default: "" },
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-hold-or-not-slide] {}
</style>
